module.exports = __webpack_public_path__ + "static/media/google-play.c8a23df9.svg";